import Checkbox from "@atoms/inputs/Checkbox";
import Dropdown from "@atoms/inputs/Dropdown/Dropdown";
import SubmitButton from "@atoms/inputs/SubmitButton";
import TextField from "@atoms/inputs/TextField";

type FieldElementFactoryProps = {
  /** The field to render. */
  field: FormFields;
  /** The error message to display. */
  errorMessage: string;
  /** Whether the form is submitting. */
  isSubmitting?: boolean;
};

/** The factory component to render the field element. */
const FieldElementFactory = ({
  field,
  errorMessage,
  isSubmitting,
}: FieldElementFactoryProps): React.ReactElement => {
  switch (field.type) {
    case "text":
    case "email":
      return (
        <TextField
          type="text"
          placeholder={field.placeholder}
          name={field.name}
          onHandleChange={field.onHandleChange || (() => {})}
          errorMessage={errorMessage}
          variantClassName={field.variantClassName}
        />
      );

    case "dropdown":
      return (
        <Dropdown
          type="dropdown"
          placeholder={field.placeholder}
          name={field.name}
          onHandleChange={field.onHandleChange || (() => {})}
          options={field.options}
          isDisplaySearch={field.isDisplaySearch}
          errorMessage={errorMessage}
          variantClassName={field.variantClassName}
        />
      );

    case "checkbox":
      return (
        <Checkbox
          type="checkbox"
          label={field.label}
          name={field.name}
          onHandleChange={field.onHandleChange || (() => {})}
          errorMessage={errorMessage}
          variantClassName={field.variantClassName}
        />
      );

    case "submit":
      return (
        <SubmitButton
          type="submit"
          name="submit"
          label={field.label}
          variantClassName={field.variantClassName}
          isSubmitting={isSubmitting}
        />
      );

    default:
      return <></>;
  }
};

export default FieldElementFactory;
